import React from 'react';
import SEO from '../components/SEO';
import './TermsPage.css';

function TermsPage() {
  return (
  <>
    {/* SEO Meta Tags */}
    <SEO
      title="नियम और शर्तें - RR NEWS TV FASTEST UPDATE"
      description="RR NEWS TV FASTEST UPDATE के नियम और शर्तें पढ़ें। वेबसाइट के उपयोग से संबंधित सभी नियम।"
      keywords="नियम, शर्तें, terms and conditions, RR NEWS TV FASTEST UPDATE"
      url="/terms"
      type="website"
    />
    
  <main id="content-start" className="terms-page container">
      <header className="terms-hero reveal">
        <h1 className="terms-title">📰 RR NEWS TV FASTEST UPDATE — नियम और शर्तें</h1>
        <p className="terms-sub">(Terms and Conditions)</p>
      </header>

      <section className="terms-section card reveal">
        <p>
          वेबसाइट "RR News TV Fastest Update" (आगे "हम", "हमारा" या "पोर्टल") द्वारा संचालित की जाती है। हमारी वेबसाइट, ई-पेपर या सोशल मीडिया प्लेटफ़ॉर्म का उपयोग करने से पहले कृपया इन नियमों और शर्तों को ध्यानपूर्वक पढ़ें। इस वेबसाइट का उपयोग करना इन नियमों को स्वीकार करने के समान है।
        </p>

        <ol className="terms-list">
          <li>
            <strong>सामान्य जानकारी</strong>
            <ol>
              <li>यह वेबसाइट समाचार, विचार, रिपोर्ट, और सार्वजनिक जानकारी साझा करने हेतु बनाई गई है।</li>
              <li>वेबसाइट का संचालन संस्थापक के मार्गदर्शन में किया जाता है।</li>
              <li>वेबसाइट का उद्देश्य सटीक और विश्वसनीय समाचार प्रदान करना है, किन्तु 100% त्रुटिरहित जानकारी की गारंटी नहीं दी जा सकती।</li>
            </ol>
          </li>

          <li>
            <strong>वेबसाइट का उपयोग</strong>
            <ol>
              <li>उपयोगकर्ता वेबसाइट पर दी गई सामग्री को केवल व्यक्तिगत जानकारी के लिए पढ़ सकते हैं।</li>
              <li>उपयोगकर्ता वेबसाइट पर दी गई सामग्री को बिना लिखित अनुमति के कॉपी, पुनः प्रकाशन या व्यावसायिक उपयोग हेतु साझा नहीं कर सकता।</li>
              <li>किसी भी समाचार, लेख या फोटो को बिना लिखित अनुमति के कॉपी, पुनःप्रकाशन या व्यावसायिक उपयोग हेतु साझा नहीं किया जा सकता।</li>
              <li>उपयोगकर्ता किसी भी प्रकार की अवैध, आपत्तिजनक या भ्रामक जानकारी वेबसाइट या इसके कमेंट सेक्शन में साझा नहीं कर सकता।</li>
            </ol>
          </li>

          <li>
            <strong>सामग्री और ज़िम्मेदारी</strong>
            <ol>
              <li>वेबसाइट पर प्रकाशित खबरें या लेख भरोसेमंद स्रोतों से संकलित किए जाते हैं।</li>
              <li>वेबसाइट पर प्रकाशित किसी भी समाचार या विचार में त्रुटि पाए जाने पर उसे सुधारने का अधिकार RR News TV Fastest Update को सुरक्षित है।</li>
              <li>किसी भी समाचार या विचार में त्रुटि पाए जाने पर उसे सुधारने का अधिकार सुरक्षित है। प्रकाशित लेख या विचार लेखक के निजी मत हो सकते हैं। वेबसाइट इन विचारों से पूर्णतः सहमत होना आवश्यक नहीं है।
 वेबसाइट पर थर्ड-पार्टी या यूजर द्वारा दिए गए कमेंट्स/विचारों के लिए पोर्टल प्रत्यक्ष रूप से उत्तरदायी नहीं होगा।</li>
            </ol>
          </li>

          <li>
            <strong>कॉपीराइट और बौद्धिक संपदा अधिकार</strong>
            <ol>
              <li>इस वेबसाइट पर उपलब्ध सभी टेक्स्ट, लोगो, ग्राफिक्स, वीडियो और ऑडियो सामग्री (जैसे शहीद सम्मान अभियान और विशेष पॉडकास्ट) RR News TV की संपत्ति हैं। बिना पूर्व लिखित अनुमति के इनका किसी भी रूप में पुनरुत्पादन (Reproduction), कॉपी या व्यावसायिक उपयोग करना IT Act और कॉपीराइट अधिनियम के तहत दंडात्मक अपराध माना जाएगा।</li>
              {/* <li>किसी भी प्रकार की निजी जानकारी (जैसे ईमेल, फोन नंबर आदि) तीसरे पक्ष को बिना अनुमति साझा नहीं की जाएगी।</li> */}
              {/* <li>वेबसाइट पर कुकीज़ (Cookies) का उपयोग केवल उपयोगकर्ता अनुभव बेहतर करने के लिए किया जाता है।</li> */}
            </ol>
          </li>

          <li>
            <strong>ई-पेपर और सदस्यता</strong>
            <ol>
              <li>ई-पेपर डाउनलोड या सदस्यता लेने वाले उपयोगकर्ताओं को सत्य जानकारी देना आवश्यक है।</li>
              <li>ई-पेपर की प्रतिलिपि केवल व्यक्तिगत उपयोग के लिए है — पुनर्वितरण या बिक्री निषिद्ध है।
किसी भी अनुचित उपयोग पर सदस्यता रद्द की जा सकती है।</li>
              {/* <li>किसी भी अनुचित उपयोग पर सदस्यता रद्द की जा सकती है।</li> */}
            </ol>
          </li>

          <li>
            <strong>तृतीय पक्ष लिंक (Third Party Links)</strong>
            <p>वेबसाइट में अन्य वेबसाइटों के लिंक दिए जा सकते हैं, जो केवल सुविधा हेतु हैं। RR News TV Fastest Update उन वेबसाइटों की सामग्री या गोपनीयता नीति के लिए ज़िम्मेदार नहीं होगा।</p>
          </li>

          <li>
            <strong>आईटी अधिनियम और शिकायत निवारण (IT Act & Grievance Redressal) (नया महत्वपूर्ण खंड)</strong>
            <ol>
              <li>यह पोर्टल सूचना प्रौद्योगिकी (मध्यवर्ती दिशानिर्देश और डिजिटल मीडिया आचार संहिता) नियमों के प्रावधानों का पालन करता है।</li>
              <li>यदि किसी भी पाठक या दर्शक को किसी प्रकाशित समाचार या सामग्री पर कोई आपत्ति है, तो वह हमारे आधिकारिक ईमेल (rrofficial893@gmail.com) पर लिखित शिकायत दर्ज करा सकता है, जिसका नियमानुसार समाधान किया जाएगा।</li>
            </ol>
          </li>

<li>
            <strong>कानूनी अधिकार</strong>
            <ol>
              <li>किसी भी विवाद की स्थिति में न्यायिक अधिकार क्षेत्र मुरादाबाद (उत्तर प्रदेश) रहेगा।</li>
              <li>उपयोगकर्ता सहमत हैं कि सभी कानूनी मामले भारत के लागू कानूनों के अंतर्गत सुलझाए जाएंगे।</li>
            </ol>
          </li>
          <li>
            <strong>संशोधन का अधिकार</strong>
            <ol>
              <li>RR News TV Fastest Update इन नियमों और शर्तों को किसी भी समय संशोधित या अद्यतन करने का अधिकार रखता है।</li>
              <li>उपयोगकर्ताओं को सलाह दी जाती है कि वे समय-समय पर इस पेज को पुनः देखें।</li>
            </ol>
          </li>

          <li>
            <strong>संपर्क करें</strong>
            <p>कार्यालय का पता: मोहम्मद हयातपुर उर्फ खोखरा, बिलारी से जारगांव रोड, बिलारी, मुरादाबाद - 244415 (उत्तर प्रदेश)</p>
            <p>📧 ईमेल: rrofficial893@gmail.com<br/>📞 फ़ोन/व्हाट्सएप: +91-8979916908<br/>🌐 वेबसाइट: https://rrnewstv.com</p>
          </li>
        </ol>
      </section>

      <footer className="terms-footer reveal">
        <p>किसी भी अन्य प्रश्न के लिए हमसे संपर्क करें — हम आपकी सहायता के लिए उपलब्ध हैं।</p>
      </footer>
    </main>
  </>
  );
}

export default TermsPage;


